import { __assign } from 'tslib';
import React__default from 'react';
import { activeBusinessFiltersState, useFilterDelete, getActiveFiltersExceptFolder, dataViewReferencesSelectors, serializeComplexeParamsForRecoil, buildOptimizedLightDataviewElementsSelector, KpkFilterType, BusinessFilterNature, MediaField, convertKpkFilterToBusinessFilter, convertBusinessFilterToKpkFilter } from '@keepeek/commons';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import ActiveFilters from '../Filters/ActiveFilters/index.js';
import { withSuspense } from '../withSuspense/index.js';

var PanelActiveFilters = function (_a) {
    var filtersConfiguration = _a.filtersConfiguration, dataViewKey = _a.dataViewKey, KIcon = _a.KIcon, _b = _a.hideFolderFiterInActiveFilters, hideFolderFiterInActiveFilters = _b === void 0 ? true : _b;
    var t = useTranslation("refront-components").t;
    var activeFiltersState = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var deleteFilter = useFilterDelete(dataViewKey);
    var activeFiltersExceptFolder;
    if (hideFolderFiterInActiveFilters) {
        activeFiltersExceptFolder = getActiveFiltersExceptFolder(activeFiltersState);
    }
    var activeFilters = hideFolderFiterInActiveFilters
        ? activeFiltersExceptFolder
        : activeFiltersState;
    // use loadable here to avoid component to suspense
    var references = useRecoilValueLoadable(dataViewReferencesSelectors(serializeComplexeParamsForRecoil(buildOptimizedLightDataviewElementsSelector({
        key: dataViewKey,
        filters: activeFilters || null,
        filtersConfiguration: filtersConfiguration,
        enableFacets: true
    }))));
    var activeFiltersWithoutFacets = [];
    activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.forEach(function (af) {
        if (af.filter.type === KpkFilterType.RadioFacet || af.filter.type === KpkFilterType.Checkbox) {
            var valuesWithoutFacetsCount_1 = [];
            af.filter.values.map(function (value) {
                var _a, _b, _c, _d, _e, _f;
                valuesWithoutFacetsCount_1.push(__assign(__assign({}, value), { title: (_c = (_b = String((_a = value === null || value === void 0 ? void 0 : value.title) !== null && _a !== void 0 ? _a : "").split(" (")) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : "", label: (_f = (_e = String((_d = value === null || value === void 0 ? void 0 : value.title) !== null && _d !== void 0 ? _d : "").split(" (")) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : "" }));
                return value; // ESLint map() expects a return value
            });
            activeFiltersWithoutFacets.push(__assign(__assign({}, af), { filter: __assign(__assign({}, af.filter), { values: valuesWithoutFacetsCount_1 }) }));
        }
        else if (af.nature === BusinessFilterNature.ADVANCED &&
            af.filter.id === MediaField.FOLDER_ID) {
            activeFiltersWithoutFacets.push(__assign(__assign({}, af), { filter: __assign(__assign({}, af.filter), { label: t("filter.advanced.folder.label") }) }));
        }
        else {
            activeFiltersWithoutFacets.push(af);
        }
    });
    return (React__default.createElement(ActiveFilters, { onFilterDelete: function (kpkFilter) { return deleteFilter(convertKpkFilterToBusinessFilter(kpkFilter)); }, filters: activeFiltersWithoutFacets.map(convertBusinessFilterToKpkFilter), references: references === null || references === void 0 ? void 0 : references.contents, KIcon: KIcon }));
};
var PanelActiveFilters$1 = withSuspense(PanelActiveFilters);

export { PanelActiveFilters$1 as default };
//# sourceMappingURL=PanelActiveFilters.js.map
